export default __webpack_public_path__ + "static/img/refido-auto-refinance-red-car.efbe653.png";